import { Component, Enum, _decorator } from 'cc';
import GameDependency from './GameDependency';
import globalInstance, { GlobalInstanceEnum } from './GlobalInstance';

const { ccclass, executionOrder, disallowMultiple, property } = _decorator;

@ccclass('GameDependencyController')
@executionOrder(-1)
@disallowMultiple
export default class GameDependencyController extends Component {
    @property({ type: Enum(GlobalInstanceEnum) })
    private readonly gameKey: GlobalInstanceEnum = GlobalInstanceEnum.game;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    protected __preload() {
        const game = globalInstance.games[this.gameKey];
        this.getComponentsInChildren(GameDependency).forEach((comp) => {
            comp.game = game;
        });
    }
}
